<div
  *ngIf="category$ | async as category"
  [style.backgroundColor]="category.colour.value"
  [matTooltip]="category.name"
  fxFill
></div>
